import React, { useEffect, useState } from "react";
import { corefetch, ImageURL } from "../../../Util/axios_core_helper";

export const RentalGuidelines = () => {
  const [guidelines, setguidelines] = useState([]);

  useEffect(() => {
    const fetchguidelines = async () => {
      try {
        const data = await corefetch("RentalGuidlines/GetGuidlinesDetails");
        setguidelines(data);
      } catch (error) {
        console.error("Error fetching guidelines data:", error);
      }
    };

    fetchguidelines();
  }, []);

  return (
    <div>
      <section className="services2" data-scroll-index={1}>
        <div className="container">
          <div className="row mb-30">
            <div className="col-md-3">
              <div className="sub-title border-bot-light">Discover</div>
            </div>
            <div className="col-md-9">
              <div className="section-title">
                Rental Guideline & Requirements
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              {/* <div class="owl-carousel owl-theme"> */}
              {guidelines.map((guideline) => (
                <div
                  key={guideline.rentalGuidlinesID}
                  className="services2 left"
                >
                  <figure>
                    <img
                      src={`${ImageURL}${guideline.imagePath}`}
                      alt="Rental Item"
                      className="img-fluid"
                    />
                  </figure>
                  <div className="caption padding-left">
                    <p>{guideline.mainDescription}</p>
                    <div className="info-wrapper mt-20">
                      <div className="butn-dark">
                        <a href="/rentalGuidlinesDetails">
                          <span>Explore</span>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default RentalGuidelines;
